import { Site, SLD } from '@patsnap-utils/biz';
export function getHelpCenterItems(vm, serviceCountry) {
    const appendItems = [
        {
            icon: 'SolidCalendar7',
            href: '//help.patsnap.com/hc/en-us/sections/8496364103837-What-s-New',
            label: vm.$t('snapBusiness.headerV2.releaseLog'),
        },
        {
            icon: 'SolidGlobal',
            href: new Site({ sld: SLD.ANALYTICS, pathname: 'status' }).href,
            label: vm.$t('snapBusiness.headerV2.data'),
        },
    ];
    if (serviceCountry.toUpperCase() === 'CN') {
        appendItems[0].href = new Site({ sld: SLD.HELP, pathname: 'help/15430876739609/article/15432629174425?categoryId=15429297885337' }).href;
        return [
            {
                icon: 'SolidHelpCentre',
                href: new Site({ sld: SLD.HELP, pathname: 'help/workspace' }).href,
                label: vm.$t('snapBusiness.headerV2.growth.helpCenter'),
            },
            ...appendItems,
            {
                icon: 'SolidBookmarkBook',
                href: new Site({ sld: SLD.COURSE_2C, pathname: '#/profession/industryDetail/1713748928955609090' }).href,
                label: vm.$t('snapBusiness.headerV2.growth.courseLearning'),
            },
            // {
            //     icon: 'SolidUsers',
            //     href: 'https://talk.zhihuiya.com/?source13=workspace',
            //     label: vm.$t('snapBusiness.headerV2.growth.patsnapCommunity'),
            // },
            null,
            {
                icon: 'Term',
                href: 'https://www.zhihuiya.com/legal/terms',
                label: vm.$t('snapBusiness.headerV2.growth.terms'),
            },
            {
                icon: 'Privacy',
                href: 'https://www.zhihuiya.com/legal/privacy',
                label: vm.$t('snapBusiness.headerV2.growth.policy'),
            },
        ];
    }
    const usHelpLink = new Site({ sld: SLD.HELP, pathname: 'hc' }).href;
    const ukHelpLink = 'https://patsnap.zendesk.com/auth/v2/login/continue_with_sso_tracking?auth_origin=4665402834717%2Cfalse%2Ctrue&brand_id=4665402834717&locale=en-us&remote_auth_id=18719448547741&return_to=https%3A%2F%2Fpatsnap.zendesk.com%2Fhc%2Fen-us&role=end_user&theme=hc';
    return [
        {
            icon: 'SolidHelpCentre',
            href: serviceCountry.toUpperCase() === 'US' ? usHelpLink : ukHelpLink,
            label: vm.$t('snapBusiness.headerV2.growth.helpCenter'),
        },
        {
            icon: 'SolidVideoExist',
            href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/sections/8496364813213-Video-Guides' }).href,
            label: vm.$t('snapBusiness.headerV2.growth.startVideos'),
        },
        // {
        //     icon: 'SolidUsers',
        //     href: 'https://help.patsnap.com/hc/en-us/community/topics',
        //     label: vm.$t('snapBusiness.headerV2.growth.patsnapCommunity'),
        // },
        ...appendItems,
        {
            icon: 'SolidConversation',
            href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/requests/new' }).href,
            label: vm.$t('snapBusiness.headerV2.growth.askForHelp'),
        },
        null,
        {
            icon: 'Term',
            href: 'https://www.patsnap.com/legal',
            label: vm.$t('snapBusiness.headerV2.growth.terms'),
        },
        {
            icon: 'Privacy',
            href: 'https://www.patsnap.com/legal/privacy-policy',
            label: vm.$t('snapBusiness.headerV2.growth.policy'),
        },
    ];
}
